import {
	ALL_CAMPAIGN,
	ALL_ASSIGNED_CAMPAIGNS,
	ERR_CAMPAIGN,
	UPDATE_ASSIGN_CAMPAIGN,
} from "../actions/actionTypes";

const initialState = {
	campaigns: [],
	assignedCampaigns: [],
	updateAssignedCampaigns: [],
	loading: true,
	errors: {},
};

export default function campaignReducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case ALL_CAMPAIGN:
			return {
				...state,
				campaigns: payload,
				loading: false,
			};
		case ALL_ASSIGNED_CAMPAIGNS:
			return {
				...state,
				assignedCampaigns: payload.data,
				loading: false,
			};


		case UPDATE_ASSIGN_CAMPAIGN:
			return {
				...state,
				updateAssignedCampaigns: payload,
				loading: false,
			};
		case ERR_CAMPAIGN:
			return {
				...state,
				errors: payload,
				loading: false,
			};
		default:
			return state;
	}
}
